import { combineReducers } from 'redux'
import userReducer from './userReducer'
import configReducer from './configReducer'
import provinceReducer from './provinceReducer'
import zoneReducer from './zoneReducer'
import communeReducer from './communeReducer'
import countryReducer from './countryReducer'
import cityReducer from './cityReducer'
import sidebarReducer from './sidebarReducer'
import memberReducer from './memberReducer'
import dashboardReducer from './dashboardReducer'
import organeReducer from './organeReducer'
import pageStateReducer from './pageStateReducer'
import cardReducer from './cardReducer'

export default combineReducers({
  users: userReducer,
  app: configReducer,
  provinces: provinceReducer,
  zones: zoneReducer,
  communes: communeReducer,
  countries: countryReducer,
  cities: cityReducer,
  sidebar: sidebarReducer,
  members: memberReducer,
  dashboard: dashboardReducer,
  organes: organeReducer,
  pages: pageStateReducer,
  cards: cardReducer,
})
